export default __webpack_public_path__ + "static/media/2018-09-23-Paul.9d93c3a5.jpg";